import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'approval-data-renderer',
  templateUrl: './approval-data-renderer.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class ApprovalDataRendererComponent implements ICellRendererAngularComp {

  status: number;
  approverName: string;
  approvalData: string;
  constructor() { }

  initilize(params: ICellRendererParams) {
    if (params && params.data) {
      this.status = params.data.status;
      this.approverName = params.data.approverName;
      this.approvalData = params.data.approvalData;
    }
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}
